'use client';

import { useBioHashScroll } from '../hooks/useBioHashScroll';

/**
 * Renders nothing — mounts the visitor automatic-jump behaviour once, from the
 * bio shell layout, so it survives content-tab navigation. See
 * {@link useBioHashScroll}.
 */
export function BioLinkScroller() {
  useBioHashScroll();
  return null;
}
